// let pos = null
// window.onpopstate = (event) => {
//   if (event.state && event.state.position) {
//     window.parent.postMessage((!pos || pos > event.state.position) ? -1 : 1, '*')
//     pos = event.state.position
//   }
// }

import Vue from 'vue'
import App from '@/App.vue'
import mixins from '@/mixins'
import router from '@/router'
import store from '@/store'

Vue.config.productionTip = false

import '@/lib/axios'
import '@/lib/font'
import '@/lib/bootstrap'
import '@/lib/icons'

(async () => {

  if (!window.location.href.includes('false')) store.state.banner = true
  store.state.flave = window.location.href.includes('token')

  await store.dispatch('initializeProgram')

  const stamp = Math.floor((new Date()).getTime() / 1000)
  const event = new Date((stamp + 7200) * 1000)
  const eventDate = event.getUTCFullYear().toString()
    + '-' + (event.getUTCMonth() + 1).toString().padStart(2, '0')
    + '-' + event.getUTCDate().toString().padStart(2, '0')

  const key = store.state.days.findIndex(day => day.date === eventDate)
  store.commit('setProgramDay', (key >= 0) ? key + 1 : 1)

  router.addRoute({
    path: '/',
    redirect: '/program/' + store.state.day + '/horizontal',
  })

  new Vue({
    mixins: [mixins],
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

})()
